




























































































































































































































































































import {
  apiMerchantStoreGetStoreIntroduction,
  apiOrderExchangeGoodsExchangeGoodsPreOrder,
  ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest,
  apiShoppingCartQuantity,
  apiSubscribeCommodityArrivalReminderAdd,
  apiSubscribeCommodityArrivalReminderStatus,
  ApiTradeGeneralTradePreOrderRequest,
} from '@/api'
import {
  computed,
  nextTick,
  onMounted,
  onUpdated,
  ref,
  watch,
} from '@vue/composition-api'
import { currentSaleChannelId } from '@/channel'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useQuery } from '@/hooks'
import { devOrProd, submit } from '@/utils'
import { globalModel } from '@/model'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        onMounted(() => {
          this.updateHeight()
          this.getCartCount()
        })

        onUpdated(() => {
          this.updateHeight()
        })
        watch(
          () => this.isSold.value,
          () => {
            if (this.isSold.value) {
              this.getcommodityArrivalReminderStatus()
            }
          },
          { immediate: true },
        )
      }

      query = useQuery<{
        goodsId: string
        exchangeCommodityId: string
        type: string
        skuId: string
        parentOrderNo: string
      }>()

      // 商品数据
      goodsData = goodsProvider.inject()

      // 兑换商品sku信息
      virtualSkuInfo = computed(() => this.goodsData.value.virtualSkuInfo)

      // 秒杀信息
      seckillInfo = computed(() => this.goodsData.value.seckillInfo)

      // 店铺是否休息
      isRest = computed(() => this.goodsData.value.storeStatus === 4)

      // 是否卖光
      isSold = computed(() => this.goodsData.value.isSold)

      // 购物车商品数量
      cartCount = ref(0)

      // 是否添加商品到货提醒状态
      isAddCommodityArrivalReminder = ref(false)

      // 操作栏高度
      height = ref(0)

      // 更新高度
      updateHeight = () => {
        this.height.value =
          (document.querySelector(`.${ctx._.actions}`)?.clientHeight || 0) +
          (document.querySelector(`.${ctx._.tips}`)?.clientHeight || 0)
      }

      // 获取购物车数量
      getCartCount = async () => {
        const { quantity } = await apiShoppingCartQuantity()
        this.cartCount.value = quantity
      }

      // 点击积分提示
      handlePointClick = () => {
        dcb.navigateTo({
          url: devOrProd(
            `https://h5p-gw.duotest.cn/app/qianbei-mall/#/goods/index?goodsId=${this.goodsData.value.commodityId}&isFull=true&isLogin=true&isAuth=true`,
            `https://h5p-gw.gogpay.cn/app/qianbei-mall/#/goods/index?goodsId=${this.goodsData.value.commodityId}&isFull=true&isLogin=true&isAuth=true`,
          ),
        })
      }

      // 点击首页
      handleHomeClick = () => {
        navigateTo('HomeIndex')
      }

      // 点击客服
      handleContactClick = () => {
        submit(async $ => {
          $.start()
          const martData = await apiMerchantStoreGetStoreIntroduction({
            storeId: this.goodsData.value.merchantId,
          })
          dcb.makePhoneCall({
            phoneNumber: martData.storePhone!,
          })
        })
      }

      // 点击店铺
      handleMartClick = () => {
        navigateTo('MartIndex', {
          id: this.goodsData.value.merchantId,
        })
      }

      // 点击收藏
      handleFavoriteClick = () => {
        this.goodsData.value.favorite()
        // TODO: 需后端提供批量查询
        // this.goodsData.skuPicker = {
        //   visible: true,
        //   action: 'favorite',
        // }
      }

      // 点击购物车
      handleCartClick = () => {
        navigateTo('CartIndex')
      }

      // 点击到货提醒
      handleNoticeClick = () => {
        submit(async $ => {
          $.start()
          await apiSubscribeCommodityArrivalReminderAdd({
            commodityId: this.goodsData.value.commodityId,
            skuId: this.goodsData.value.selectedSku.skuId,
          })
          this.isAddCommodityArrivalReminder.value = true
          await $.success('已添加到货提醒')
        })
      }

      // 获取到货提醒
      getcommodityArrivalReminderStatus = async () => {
        const { status } = await apiSubscribeCommodityArrivalReminderStatus({
          commodityId: this.goodsData.value.commodityId,
          skuId: this.goodsData.value.selectedSku.skuId,
        })

        this.isAddCommodityArrivalReminder.value = !!status
      }

      // 点击加入购物车
      handleAddCartClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'addCart',
          callback: () => this.getCartCount(),
        })
      }

      // 点击购买
      handleBuyClick = async () => {
        if (this.query.type === 'exchange') {
          if (!this.virtualSkuInfo.value.cutStock) {
            return
          }
          const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
            preOrderType: 2 as any,
            deviceId: globalModel.state.currentDeviceId,
            tvHotelId: globalModel.state.tvHotelId,
            tvHotelRoomNo: globalModel.state.tvHotelRoomNo,
            skuInfo: [
              {
                commodityId: this.goodsData.value.commodityId,
                count: 1,
                sellChannelId: currentSaleChannelId,
                skuId: this.query.skuId,
              },
            ],
          } as any
          const preOrderRequestData1: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest =
            {
              commodityId: this.goodsData.value.commodityId,
              exchangeCommodityId: this.query.exchangeCommodityId,
              parentOrderNo: this.query.parentOrderNo,
              skuId: this.query.skuId,
            }

          const res = await apiOrderExchangeGoodsExchangeGoodsPreOrder(
            preOrderRequestData1,
          )

          nextTick(() => {
            navigateTo('OrderPlace', {
              type: 'normal',
              sourceType: this.query.type,
              data: JSON.stringify(res),
              preOrderRequestData: JSON.stringify(preOrderRequestData),
              preOrderRequestData1: JSON.stringify(preOrderRequestData1),
              preOrderResponseData: JSON.stringify(res),
            })
          })
        } else {
          this.goodsData.value.showSkuPicker({
            action: 'buy',
          })
        }
      }

      // 点击秒杀
      handleSeckillClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'buy',
        })
      }

      // 点击发起拼团
      handleGroupBuyClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'groupBuying',
        })
      }
    },
)
